interface NoDataProps {
  message: string;
}

function NoData({ message }: NoDataProps) {
  return <>{message}</>;
}

export default NoData;
